
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/dbt-cloud",
      function () {
        return require("private-next-pages/extensions/dbt-cloud.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/dbt-cloud"])
      });
    }
  